import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, off } from "firebase/database";

const firebaseConfig = {
  projectId: "reachiq-app",
  databaseURL: "https://reachiq-app-default-rtdb.firebaseio.com",
};

console.log("[Firebase] Initializing with config:", firebaseConfig);

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

console.log("[Firebase] Database instance created:", !!database);

export { database, ref, onValue, off };
